import { render, staticRenderFns } from "./InvoiceElement.vue?vue&type=template&id=6747a6b4&scoped=true&"
import script from "./InvoiceElement.vue?vue&type=script&lang=js&"
export * from "./InvoiceElement.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceElement.vue?vue&type=style&index=0&id=6747a6b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6747a6b4",
  null
  
)

export default component.exports